export const composeMeasurement = (height, width, depth) => {
  return `${height ? `Alto ${height} mm,` : ''}${
    width ? ` Ancho ${width} mm,` : ''
  }${depth ? ` Fondo ${depth} mm` : ''}`
}
